import { Button, Flex, IconPlus, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { FieldGroupBox } from 'ui'
import styles from '../../styles'
import { messages } from '../messages'

type Props = {
  name: string
  onAdd: () => void
}

export function EmptyTrigger(props: Props) {
  const { name, onAdd } = props

  return (
    <FieldGroupBox name={name}>
      <Flex direction="column" className={styles.view.content}>
        <Text variant="action1">
          <FormattedMessage {...messages.empty.description} />
        </Text>
        <Button variant="secondary" icon={<IconPlus />} onClick={onAdd}>
          <FormattedMessage {...messages.empty.addItems} />
        </Button>
      </Flex>
    </FieldGroupBox>
  )
}
